module.exports = function now () {
  return new Date().toISOString()
}



//////////////////
// WEBPACK FOOTER
// ./~/pouchdb-hoodie-api/lib/utils/now.js
// module id = 751
// module chunks = 7